import React from 'react';
import {Grid, Typography, IconButton} from '@mui/material';
import {styled} from '@mui/material/styles';
import AurIcon, {IconNames} from '../common/aur-icon/AurIcon';
import {t} from 'i18next';

// Custom styled header container
const HeaderContainer = styled(Grid)(() => ({
  color: '#FFFFFF', // White text color
  borderBottom: '1px solid #333', // Border between items
}));

const SquareIconButton = styled(IconButton)(() => ({
  borderRadius: 8, // Remove border-radius for a square shape
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)', // Optional: Adjust hover background color
  },
}));

const BranchHeader: React.FC<{
  branchName: string;
  isExpanded: boolean;
  onClick: () => void;
  disabledHeaderIcon?: boolean;
}> = ({branchName, isExpanded, disabledHeaderIcon = false, onClick}) => {
  const expandButtonLabel = isExpanded
    ? t('clientDetailsPage.projectDrawer.collapseBranch', {
        branchName
      })
    : t('clientDetailsPage.projectDrawer.expandBranch', {
        branchName,
      });
  const toggleIcon = (expanded: boolean) => {
    if (expanded) {
      return <AurIcon icon={IconNames.ChevronUp} />;
    }
    return <AurIcon icon={IconNames.ChevronDown} />;
  };
  return (
    <HeaderContainer
      className="client-detail-tile-header"
      container
      alignItems="center"
    >
      <SquareIconButton
        disabled={disabledHeaderIcon}
        onClick={onClick}
        data-testid="aur-stacked-header-expand-button"
        aria-label={expandButtonLabel}
        aria-expanded={isExpanded}
      >
        {toggleIcon(isExpanded)}
      </SquareIconButton>
      <Typography className="tile-header-text">
        {t('clientDetailsPage.projectDrawer.branchLabels')}{' '}
        <span data-testid="aur-test-branch-header-text" className="mist-100">
          {branchName}
        </span>
      </Typography>
    </HeaderContainer>
  );
};

export default BranchHeader;
